import './PdfSplittingModalRowStyle.less';

import { range } from 'lodash';
import React from 'react';
import ReactImageMagnify from 'react-image-magnify';

import { Icon, NumberInput, SingleLineInput } from '@opendoor/bricks';
import Divider from './Divider';
import { IDocumentMetadata } from './PdfSplittingModal';

export interface IPdfSplittingModalRowProps {
  document: IDocumentMetadata;
  index: number;
  onRenameDocument: (index: number, displayName: string | number) => void;
  onRemoveDocument: (index: number) => void;
  onUpdateEndPage: (name, value) => void;
  onUpdateStartPage: (name, value) => void;
  required: boolean;
  pageImageData: string[] | null;
}

const PDF_ZOOMED_IN_WIDTH = 800;
const PAPER_LETTER_RATIO = 8.5 / 11; // most documents are 8.5" x 11" in size

export default class PdfSplittingModalRow extends React.PureComponent<IPdfSplittingModalRowProps> {
  public handleRemoveDocument = () => {
    const { index, onRemoveDocument } = this.props;

    onRemoveDocument(index);
  };

  public handleRenameDocument = (name: string, value: string | number) => {
    const { index, onRenameDocument } = this.props;

    onRenameDocument(index, value);
  };

  public handleUpdateStartPage = (name: string, value?: number) => {
    const { index, onUpdateStartPage } = this.props;

    onUpdateStartPage(index, value);
  };

  public handleUpdateEndPage = (name: string, value?: number) => {
    const { index, onUpdateEndPage } = this.props;

    onUpdateEndPage(index, value);
  };

  public canRenderPreviews(): boolean {
    const { document, pageImageData } = this.props;

    return (
      document &&
      pageImageData &&
      document.startPage &&
      document.endPage &&
      !document.isNameInvalid &&
      !document.isPageDataInvalid &&
      document.startPage <= document.endPage &&
      document.endPage - document.startPage < pageImageData.length
    );
  }

  public render(): JSX.Element {
    const { document, required, pageImageData } = this.props;

    return (
      <div>
        <div className="row pdf-splitting-modal-row">
          <div className="col-md-1">
            {!required && (
              <button
                className="pdf-splitting-modal-remove-button"
                onClick={this.handleRemoveDocument}
              >
                <Icon name="minus-filled" />
              </button>
            )}
          </div>
          <div className="col-md-6">
            {required ? (
              <strong className="document-type">{document.displayName}</strong>
            ) : (
              <SingleLineInput
                className="pdf-splitting-modal-name-input"
                content={document.displayName}
                hasError={document.isNameInvalid}
                onChange={this.handleRenameDocument}
                name="Name Input"
                placeholder="Additional Document"
              />
            )}
          </div>
          <div className="row col-md-5">
            <div className="row number-inputs">
              <NumberInput
                className="col-md-4 col-md-offset-2 pdf-splitting-modal-start-page-input"
                decimalPlaces={0}
                content={document.startPage}
                hasError={document.isPageDataInvalid}
                name="start"
                onChange={this.handleUpdateStartPage}
                placeholder={'0'}
              />
              <p className="hyphen-between-number-inputs"> - </p>
              <NumberInput
                className="col-md-4 pdf-splitting-modal-end-page-input"
                content={document.endPage}
                decimalPlaces={0}
                hasError={document.isPageDataInvalid}
                name="end"
                onChange={this.handleUpdateEndPage}
                placeholder={'0'}
              />
            </div>
          </div>
        </div>
        {this.canRenderPreviews() && (
          <div className="row page-previews-row">
            <div className="col-md-offset-1 col-md-11">
              {range(document.startPage, document.endPage + 1).map((page: number) => (
                <div key={page} className="page-thumbnail">
                  <ReactImageMagnify
                    smallImage={{
                      isFluidWidth: true,
                      src: pageImageData[page - 1],
                    }}
                    largeImage={{
                      height: PDF_ZOOMED_IN_WIDTH / PAPER_LETTER_RATIO,
                      src: pageImageData[page - 1],
                      width: PDF_ZOOMED_IN_WIDTH,
                    }}
                    imageClassName="small-image"
                    isHintEnabled={false}
                    enlargedImagePosition="over"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        <Divider />
      </div>
    );
  }
}
